import { useLayoutEffect, useRef, useState } from 'react';
import { Sparkle } from './Shared';
import './Footer.css';

const WORDMARK = 'glanz beginnt hier';

export const FooterWordmark = () => {
  const textRef = useRef(null);
  const measureRef = useRef(null);
  const [letters, setLetters] = useState([]);

  useLayoutEffect(() => {
    let active = true;
    const measure = () => {
      if (!active) return;
      const node = measureRef.current.firstChild;
      const left = textRef.current.getBoundingClientRect().left;
      const range = document.createRange();
      // Keep the original, continuously shaped text as the layout reference.
      // Range positions preserve kerning and responsive spacing between letters.
      const positions = Array.from(WORDMARK, (character, index) => {
        range.setStart(node, index);
        range.setEnd(node, index + 1);
        return { character, index, left: range.getBoundingClientRect().left - left };
      });
      setLetters(positions.filter(letter => letter.character !== ' '));
    };
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(textRef.current);
    document.fonts.ready.then(measure);
    return () => { active = false; observer.disconnect(); };
  }, []);

  return (
    <div className="footer-wordmark" aria-hidden="true" data-testid="footer-wordmark">
      <span ref={textRef} className="footer-wordmark-text" data-ready={letters.length > 0} data-testid="footer-wordmark-text">
        <span ref={measureRef} className="footer-wordmark-measure" data-testid="footer-wordmark-original">{WORDMARK}</span>
        {letters.map(({ character, index, left }) => (
          <span
            key={index}
            className="footer-wordmark-letter"
            style={{ left, '--wave-delay': `${index * 0.11}s` }}
            data-testid={`footer-wordmark-letter-${index}`}
          >{character}</span>
        ))}
      </span>
      <Sparkle className="footer-wordmark-star" data-testid="footer-wordmark-star" />
    </div>
  );
};